import * as React from 'react';
import { NavHeaderContext } from '../hoc/withNavHeader';

export const useNavHeader = () => React.useContext(NavHeaderContext);
